import { EventInviteeId } from "@sp-crm/core";

export interface OutcomeEvent {
    startsAt: string;
    eventDuration: number;
    status: string;
}

export interface AttendanceCandidate {
    id: EventInviteeId;
    rsvpResponse?: string | null;
    attended?: boolean | null;
}

export const eventEndsAt = (event: OutcomeEvent): Date =>
    new Date(new Date(event.startsAt).getTime() + event.eventDuration * 60 * 1000);

export const hasFinished = (event: OutcomeEvent, now: Date): boolean =>
    now >= eventEndsAt(event);

export const isAwaitingOutcome = (event: OutcomeEvent, now: Date): boolean =>
    event.status === "scheduled" && hasFinished(event, now);

export const defaultAttendance = (invitees: AttendanceCandidate[]): EventInviteeId[] =>
    invitees.filter(invitee => invitee.rsvpResponse === "yes").map(invitee => invitee.id);

export const initialAttendance = (invitees: AttendanceCandidate[]): EventInviteeId[] => {
    const alreadyRecorded = invitees.some(
        invitee => invitee.attended === true || invitee.attended === false,
    );
    return alreadyRecorded
        ? invitees.filter(invitee => invitee.attended).map(invitee => invitee.id)
        : defaultAttendance(invitees);
};

export const toggleAttendance = (
    attended: EventInviteeId[],
    inviteeId: EventInviteeId,
): EventInviteeId[] =>
    attended.includes(inviteeId)
        ? attended.filter(existing => existing !== inviteeId)
        : [...attended, inviteeId];

export const attendanceSummary = (attendedCount: number, total: number): string => {
    if (total === 0) {
        return "No one was invited.";
    }
    const noun = attendedCount === 1 ? "guest" : "guests";
    return `${attendedCount} of ${total} ${noun} attended.`;
};
